import React, { Component } from "react";
import cn from "classnames";
import _defer from "lodash/defer";
import Icon from "backpack-ui/dist/components/icon";
import Button from "../../Button";
import Input from "../Input";
import Results from "../Results";
import styles from "./styles.css";

class Mobile extends Component {
  static defaultProps = {
    searchResults: [],
  };

  constructor(props) {
    super(props);
    this.state = {};

    this.inputRef = React.createRef();
  }

  componentDidMount() {
    _defer(() => {
      this.inputRef.current.focus();
    });
  }

  componentWillUnmount() {
    this.inputRef.current.blur();
  }

  render() {
    const {
      className,
      searchResults,
      searchTerm,
      onClose,
      onChange,
    } = this.props;
    const inputId = "search-input";

    return (
      <div className={cn(styles.search, className)}>
        <form
          action="https://www.lonelyplanet.com/search"
          className={styles.container}
        >
          <Button
            element="label"
            className={styles.button}
            htmlFor={inputId}
            tabIndex={0}
          >
            <Icon.Search label="Search" />
          </Button>

          <Input
            ref={this.inputRef}
            className={styles.input}
            id={inputId}
            tabIndex={0}
            name="q"
            onChange={onChange}
          />

          <Button
            className={styles.button}
            type="button"
            onClick={onClose}
            tabIndex={0}
          >
            <Icon.Close label="Close search" />
          </Button>
        </form>
        {searchResults.length > 0 && (
          <Results
            className={styles.results}
            searchResults={searchResults}
            searchTerm={searchTerm}
          />
        )}
      </div>
    );
  }
}

export default Mobile;
